import * as z from "zod/mini";
const flowCommandKinds = ["open", "prefetch", "prerender"];
const nonFlowCoreCommandKinds = [
    "hostContextUpdated",
    "hostSignal",
    "setTargetingPlan",
    "telemetry",
    "identify",
    "track",
    "configure",
    "init",
    "close",
    "reset",
    "instanceFeedback.capture",
    "instanceFeedback.listMine",
    "error",
];
const coreCommandKinds = [
    ...flowCommandKinds,
    ...nonFlowCoreCommandKinds,
];
const publicCommandKinds = [
    "open",
    "prefetch",
    "prerender",
    "identify",
    "updateHostContext",
    "emitHostSignal",
    "setContainer",
    "setDefaultContainerPolicy",
    "configure",
    "init",
    "close",
    "reset",
    "track",
];
export const coreCommandKindSchema = z.enum(coreCommandKinds);
export const coreCommandKindWithoutFlowResultSchema = z.enum(nonFlowCoreCommandKinds);
export const publicCommandKindSchema = z.enum(publicCommandKinds);
/** All command kinds that may appear in settlement events (core receives loader + SDK commands). */
const allCommandKinds = [...coreCommandKinds, ...publicCommandKinds];
export const allCommandKindSchema = z.enum(allCommandKinds);
